import React from 'react';

import { IconProps } from './types';

export const HeartSecondaryIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="110"
        viewBox="0 0 110 110"
        width="110"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M101.348 38.9628C98.5551 25.8797 86.8192 16.3863 73.4273 16.3863C66.6642 16.3863 60.1025 18.8346 54.9642 23.1942C49.8258 18.8346 43.2686 16.3863 36.501 16.3863C23.7894 16.3863 12.4967 24.9353 9.04131 37.1769C7.20171 43.7252 7.74777 50.721 10.5228 56.7187C18.2169 76.0278 39.4059 93.6137 54.9731 93.6137C70.7418 93.6137 91.9799 75.9159 99.5308 56.486C101.115 52.404 101.957 48.4875 102.019 44.8397C102.051 42.7002 101.814 40.6681 101.348 38.9628Z"
          fill="url(#paint0_linear_40000523_38936)"
        />
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_40000523_38936"
            x1="54.9952"
            x2="54.9952"
            y1="16.3863"
            y2="93.6137"
          >
            <stop stopColor="#FF4141" />
            <stop offset="1" stopColor="#AA1919" />
          </linearGradient>
        </defs>
      </svg>
    );
  },
);
